import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ken-burns-banner',
  templateUrl: './ken-burns-banner.component.html',
  styleUrls: ['./ken-burns-banner.component.scss'],
})
export class KenBurnsBannerComponent implements OnInit {
  images: string[] = ['assets/img/new.png'];
  currentIndex = 0;

  ngOnInit() {
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 10000); // Change every 10 seconds
  }
}
